import { gql } from '@anyx/common-graphql';

export const PRODUCT_SALES_CHANNELS = gql(/* GraphQL */ `
  query ProductSalesChannels($input: ProductSaleChannelsInput!) {
    productSaleChannels(input: $input) {
      saleChannelTypes
    }
  }
`);
